import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Heart, Users, Award, TrendingUp, CheckCircle, Shield, BookOpen, Briefcase, GraduationCap, Lightbulb, Handshake } from "lucide-react";
import api from "../../API/api";
import { notification } from "antd";
import { getMyPatronRequest } from "../../API/getters";

export default function PadrinhoPage() {
  const navigate = useNavigate();
  const [submittedPatronRequest, setSubmittedPatronRequest] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchMyPatronRequest() {
      const response = await getMyPatronRequest();
      setSubmittedPatronRequest(response);
    }
    fetchMyPatronRequest();
  }, []);

  const handleCandidacy = async () => {
    setLoading(true);
    try {
      const response = await api.post("v1/graduate/patron/");
      notification.success({
        message: "Sucesso",
        description:
          response.data.details ||
          "A sua candidatura para a iniciativa padrinho foi submetida com sucesso.",
        placement: "topRight",
      });
      setSubmittedPatronRequest(true);
    } catch (error) {
      notification.error({
        message: "Erro",
        description:
          error.response?.data?.details ||
          "Ocorreu um erro ao submeter a sua candidatura. Por favor, tente novamente mais tarde.",
        placement: "topRight",
      });
    } finally {
      setLoading(false);
    }
  };

  const categories = [
    { name: "Bronze", students: "Até 10", amount: "61.204,00 a 612.040,00", color: "bg-amber-100 text-amber-700" },
    { name: "Prata", students: "11 a 25", amount: "673.244,00 a 1.530.100,00", color: "bg-gray-200 text-gray-700" },
    { name: "Ouro", students: "26 a 50", amount: "1.591.304,00 a 3.060.200,00", color: "bg-yellow-100 text-yellow-700" },
    { name: "Diamante", students: "51 ou mais", amount: "3.121.404,00 ou mais", color: "bg-blue-100 text-blue-700" },
  ];

  return (
    <div className="w-full ">
      {/* Botão Voltar */}
     

     
      {/* Descrição Principal */}
      <div className="bg-gradient-to-r from-emerald-50/30 to-gray-50/30 rounded-2xl p-8  border border-emerald-100/30">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
            <Lightbulb className="w-5 h-5 text-emerald-600" />
          </div>
          <h2 className="text-xl font-bold text-gray-700">Surgimento da Iniciativa</h2>
        </div>
        <p className="text-gray-600 leading-relaxed mb-4">
          A iniciativa surge como resposta à redução do financiamento alocado às bolsas de estudos, devido a crise 
          financeira em Moçambique, que afecta directamente no orçamento da UEM.
        </p>
        <p className="text-gray-600 leading-relaxed">
          Para que a UEM esteja dentro dos padrões internacionais, é fundamental aumentar o número de estudantes 
          com acesso a bolsas de estudos, garantindo a permanência e frequência dos mesmos com qualidade e confiança.
        </p>
      </div>

      {/* Como aderir */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-8 mb-8">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
            <Handshake className="w-5 h-5 text-emerald-600" />
          </div>
          <h2 className="text-xl font-bold text-gray-700">Como aderir à Iniciativa</h2>
        </div>
        <p className="text-gray-600 leading-relaxed mb-4">
          Qualquer pessoa singular ou jurídica pode aderir à Iniciativa Padrinho, a ser formalizada através de 
          um Memorandum de Entendimento a ser rubricado entre o Padrinho e o Magnífico Reitor da Universidade.
        </p>
        <div className="bg-gray-50/50 rounded-xl p-5 mt-4">
          <h3 className="font-medium text-gray-800 mb-3 text-bold flex items-center gap-2">
            
            O Padrinho pode:
          </h3>
          <ul className="space-y-2">
            {[
              "Escolher o número de estudantes a apadrinhar",
              "Escolher a categoria de apoio que deseja oferecer",
              "Contribuir com um valor monetário, deixando a alocação ao critério da UEM"
            ].map((item, idx) => (
              <li key={idx} className="flex items-start gap-2 text-gray-600 text-sm">
                <CheckCircle className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
        <p className="text-sm text-gray-500 mt-4">
          As contribuições podem incluir o pagamento de propinas, subsídios mensais, material escolar, 
          alojamento e alimentação, conforme a categoria escolhida.
        </p>
      </div>

      {/* Tabela de Categorias */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-8 mb-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
            <Award className="w-5 h-5 text-emerald-600" />
          </div>
          <h2 className="text-xl font-light text-gray-700">Categorias de Padrinho</h2>
        </div>
        <p className="text-gray-500 text-sm mb-6">
          A categoria do Padrinho depende do nível de contribuição anual:
        </p>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">Categoria</th>
                <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">Nº de Afilhados</th>
                <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">Contribuição Anual (MZN)</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((cat, idx) => (
                <tr key={idx} className="border-b border-gray-100 hover:bg-gray-50/50 transition-colors">
                  <td className="py-3 px-4">
                    <span className={`inline-flex px-3 py-1 rounded-full text-xs font-medium ${cat.color}`}>
                      {cat.name}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-600">{cat.students}</td>
                  <td className="py-3 px-4 text-sm text-gray-600 font-mono">{cat.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Benefícios */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-8 mb-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
            <TrendingUp className="w-5 h-5 text-emerald-600" />
          </div>
          <h2 className="text-xl font-bold text-gray-700">Benefícios da Iniciativa</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Para UEM */}
          <div className="bg-gray-50/50 rounded-xl p-5">
            <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center mb-3">
              <GraduationCap className="w-5 h-5 text-emerald-600" />
            </div>
            <h3 className="font-medium text-gray-800 mb-3">Para a UEM</h3>
            <ul className="space-y-2">
              {[
                "Aumento do número de bolseiros apadrinhados",
                "Melhoria das condições académicas e sociais",
                "Interligação entre a Universidade e o sector produtivo"
              ].map((item, idx) => (
                <li key={idx} className="flex items-start gap-2 text-gray-600 text-sm">
                  <CheckCircle className="w-3 h-3 text-emerald-500 mt-0.5 flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Para o Padrinho */}
          <div className="bg-gray-50/50 rounded-xl p-5">
            <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center mb-3">
              <Users className="w-5 h-5 text-emerald-600" />
            </div>
            <h3 className="font-medium text-gray-800 mb-3">Para o Padrinho</h3>
            <ul className="space-y-2">
              {[                
                "Direito de preferência para a contratação",
                "Acesso privilegiado ao Magnífico Reitor",
                "Convite para eventos da Universidade",
                "Reconhecimento público como padrinho",
                "Recepçao relatórios de progresso do afilhado",
              ].map((item, idx) => (
                <li key={idx} className="flex items-start gap-2 text-gray-600 text-sm">
                  <CheckCircle className="w-3 h-3 text-emerald-500 mt-0.5 flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Para o Estudante */}
          <div className="bg-gray-50/50 rounded-xl p-5">
            <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center mb-3">
              <BookOpen className="w-5 h-5 text-emerald-600" />
            </div>
            <h3 className="font-medium text-gray-800 mb-3">Para o Estudante (Afilhado)</h3>
            <ul className="space-y-2">
              {[
                "Condições financeiras para frequentar o curso superior",
                "Acompanhamento contínuo durante o percurso académico",
                "Possibilidade de integração no mercado de emprego"
              ].map((item, idx) => (
                <li key={idx} className="flex items-start gap-2 text-gray-600 text-sm">
                  <CheckCircle className="w-3 h-3 text-emerald-500 mt-0.5 flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Botão de Ação */}
      <div className="text-center pt-4">
        {!submittedPatronRequest ? (
          <button
            onClick={handleCandidacy}
            disabled={loading}
            className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed text-white px-8 py-3 rounded-xl text-sm font-medium transition-colors shadow-sm"
          >
            {loading ? (
              <>
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                <span>Enviando...</span>
              </>
            ) : (
              <>
                <Heart className="w-4 h-4" />
                Aderir à Iniciativa Padrinho
              </>
            )}
          </button>
        ) : (
          <div className="bg-emerald-50/50 rounded-xl p-6 border border-emerald-100">
            <div className="flex items-center justify-center gap-3">
              <CheckCircle className="w-6 h-6 text-emerald-500" />
              <p className="text-gray-700">
                Já submeteu a sua candidatura para a iniciativa padrinho. Em breve entraremos em contacto.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}